<template>
  <div class="login">
    <div class="body">
      <PayHeader />
      <p class="tip">{{ $t("tip") }}</p>
      <form @submit.prevent="submit">
        <div class="form-group">
          <label class="h1" for="id">{{ $t("id") }}</label>
          <input
            id="id"
            ref="userId"
            v-model="userId"
            class="form-control"
            autocomplete="off"
            oninput="value = value.slice(0, 12)"
            :placeholder="$t('id-placeholder')"
            autofocus="autofocus"
          />
          <div v-if="[1, 2].includes(errorCode)" class="help-block">
            {{ errorMsg(errorCode)
            }}<!-- {{ $t('id-help-tip') }} -->
          </div>
        </div>

        <div class="form-group">
          <label class="h1" for="verification-code">{{
            $t("verification-code")
          }}</label>
          <div class="input-group">
            <input
              id="verification-code"
              ref="verificationCode"
              v-model="verificationCode"
              type="number"
              autocomplete="off"
              onkeydown="if(event.key==='.'){event.preventDefault()}"
              oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,''); value = value.slice(0, 6)"
              :placeholder="$t('verification-code-placeholder')"
              class="form-control"
            />
            <label for="verification-code">
              <template v-if="canObtaining">
                <span class="obtain" @click="sendVerificationCode">{{
                  $t("obtain")
                }}</span>
              </template>
              <template v-else-if="countdowning">
                <span class="count-downn"
                  >{{ $t("re-obtain") }}(<span>{{ countdown }}</span
                  >s)</span
                >
              </template>
            </label>
          </div>
          <div
            v-if="[0, 2, 3, 4, 5, 100].includes(errorCode)"
            :style="errorCode === 0 ? { color: '#00CC3D' } : {}"
            class="help-block"
          >
            {{ errorMsg(errorCode)
            }}<!-- {{ $t('id-help-tip') }} -->
          </div>
        </div>

        <div class="form-group">
          <div class="btn-wrap">
            <button :disabled="!canCheck" class="submit">
              {{ $t("check") }}
            </button>
          </div>
          <!-- <div class="help-wrap">
            <router-link to="/help" class="help">
              <span>{{ $t('using-help') }}</span>
              <img src="../../assets/image/ic_income_question@2x.webp" alt="">
            </router-link>
          </div> -->
        </div>
      </form>
    </div>

    <PayFooter help-shown />
  </div>
</template>

<script>
import Index from "./index.js";
export default Index;
</script>

<style lang="less">
@import "index.less";
</style>
